// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useCallback, useEffect, useMemo } from "react";
import { useParams } from "react-router";
import { useAppSelector } from "../store/hooks";
import { selectElectionById } from "../store/elections/electionsSlice";
import { useTranslation } from "react-i18next";
import { ROOT_CLASS_PREFIX, toValidClassName, translateFromPresentation } from "@sequentech/ui-core";
/**
 * Manages election class on <html> and provides an election class formatter.
 */
export var useElectionClassName = function () {
    var i18n = useTranslation().i18n;
    var electionId = useParams().electionId;
    var election = useAppSelector(selectElectionById(String(electionId !== null && electionId !== void 0 ? electionId : "")));
    var extractElectionName = function (election) {
        var language = i18n.resolvedLanguage || i18n.language;
        return (translateFromPresentation(election, "alias", language) ||
            translateFromPresentation(election, "name", language) ||
            election.id);
    };
    var getElectionClassName = useCallback(function (e) { return toValidClassName(extractElectionName(e)); }, [extractElectionName]);
    var activeElectionClassName = useMemo(function () {
        if (!electionId || !election)
            return null;
        return getElectionClassName(election);
    }, [electionId, election, getElectionClassName]);
    useEffect(function () {
        var appRoot = document.querySelector(".app-root");
        if (!appRoot)
            return;
        // Remove any previous e-* class we added
        for (var _i = 0, _a = Array.from(appRoot.classList); _i < _a.length; _i++) {
            var cls = _a[_i];
            if (cls.startsWith(ROOT_CLASS_PREFIX)) {
                appRoot.classList.remove(cls);
            }
        }
        if (activeElectionClassName) {
            appRoot.classList.add(activeElectionClassName);
        }
    }, [activeElectionClassName]);
    return [getElectionClassName, activeElectionClassName];
};
